var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { VideoCameraIcon, DocumentIcon, BookOpenIcon } from '@heroicons/react/24/outline';








const FileIcon = ({ mimetype = '', filename, altText, className }) => {
  let type;

  switch (true) {
    case /^image\//.test(mimetype):
      type = 'image';
      break;

    case /^audio\//.test(mimetype):
      type = 'media';
      break;

    case /^video\//.test(mimetype):
      type = 'media';
      break;

    case /^application\/pdf/.test(mimetype):
      type = 'pdf';
      break;

    default:
      type = 'other';
      break;
  }

  if (type === 'image') {
    return (/*#__PURE__*/
      _jsx("div", { className: className }, void 0, /*#__PURE__*/
      _jsx("img", {
        className: "object-scale-down w-full h-full",
        src: `/api/files/${filename}`,
        alt: altText || filename }
      )
      ));

  }

  if (type === 'media') {
    return (/*#__PURE__*/
      _jsx("div", { className: className || 'w-full h-full' }, void 0, /*#__PURE__*/
      _jsx("span", { className: "sr-only" }, void 0, altText || filename), /*#__PURE__*/
      _jsx(VideoCameraIcon, {})
      ));

  }

  if (type === 'pdf') {
    return (/*#__PURE__*/
      _jsx("div", { className: className || 'w-full h-full' }, void 0, /*#__PURE__*/
      _jsx("span", { className: "sr-only" }, void 0, altText || filename), /*#__PURE__*/
      _jsx(BookOpenIcon, {})
      ));

  }

  return (/*#__PURE__*/
    _jsx("div", { className: className || 'w-full h-full' }, void 0, /*#__PURE__*/
    _jsx("span", { className: "sr-only" }, void 0, altText || filename), /*#__PURE__*/
    _jsx(DocumentIcon, {})
    ));

};

export { FileIcon };